import React from "react";
import { useEffect, useState } from "react";
import { Loader, Message, Modal } from "rsuite";


interface GenerateResultModalProps<T> {
  promise: Promise<T>;
  open: boolean;
  onClose: () => void;
  extractImageUrl: (result: T) => string | undefined;
}
function GenerateResultModal<T>({ promise, open, onClose, extractImageUrl }: GenerateResultModalProps<T>) {

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [result, setResult] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;

    setStatus('loading');
    setResult(null);
    setError(null);

    promise
      .then(res => {
        setResult(res);
        setStatus('success');
      })
      .catch(err => {
        setError(err?.message ?? 'Unknown error');
        setStatus('error');
      });
  }, [promise, open]);

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <Modal.Header>
        <Modal.Title>Generation Result</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {status === 'loading' && (
          <div style={{ textAlign: 'center', padding: 20 }}>
            <Loader size="lg" content="Generating..." />
          </div>
        )}

        {status === 'error' && (
          <Message type="error" showIcon>
            {error}
          </Message>
        )}

        {status === 'success' && result && (
          <div style={{ textAlign: 'center' }}>
            <img
              src={extractImageUrl(result)}
              alt="Generated"
              style={{ maxWidth: '100%', borderRadius: 8 }}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className="rs-btn rs-btn-primary" onClick={onClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenerateResultModal;
